import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  ExfaLogo: {
    WebkitFilter: "grayscale(100%)" /* Safari 6.0 - 9.0 */,
    filter: "grayscale(100%)",
    top: "calc(50% - 18px)",
    left: "calc(50% - 18px)",
    position: "absolute",
  },
}));
